import { capitalize } from '@core/text/titleize';
import type { BrowseCategorySlug } from './models/BrowseCategory';

enum BrowseCategoryName {
  Cardio = 'Cardio',
  Cycling = 'Cycling',
  Outdoor = 'Outdoor',
  Strength = 'Strength',
  Stretching = 'Stretching',
  TotalBody = 'Total Body',
  Running = 'Running',
  Yoga = 'Yoga',
  Walking = 'Walking',
  Bootcamp = 'Bootcamp',
  Meditation = 'Meditation',
  Bike_bootcamp = 'Bike Bootcamp',
  Caesar = 'Rowing',
  Caesar_bootcamp = 'Row Bootcamp',
  All = 'All',
  Free = 'Free',
}

export const toAnalyticsBrowseCategoryProp = (slug: BrowseCategorySlug) => ({
  // @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'typeof BrowseCategoryName'
  browseCategory: BrowseCategoryName[capitalize(slug as string)],
});
